import React from 'react';
import LocationPicker from './components/LocationPicker';

export default function IntentOtherForm({ data, onChange }) {
    const updateBasics = (field, value) => onChange('basics', field, value);

    const { basics = {}, notes = '' } = data;

    return (
        <div className="req-grid">
            <div className="req-col-span-2">
                <h3 className="req-section-title">General Requirements</h3>
            </div>

            <div className="req-col-span-2">
                <LocationPicker
                    city={basics.city}
                    localities={basics.localities}
                    onChange={updateBasics}
                />
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Pincode</label>
                <input
                    type="text"
                    className="req-input"
                    placeholder="e.g. 560001"
                    value={basics.pincode || ''}
                    onChange={(e) => updateBasics('pincode', e.target.value)}
                />
            </div>

            <div className="req-col-span-2 req-field">
                <label className="req-label">What are you looking for?</label>
                <textarea
                    className="req-input"
                    rows={6}
                    placeholder="Describe your requirements in detail..."
                    value={notes || ''}
                    onChange={(e) => onChange('notes', null, e.target.value)}
                />
            </div>
        </div>
    );
}
